module.exports = __webpack_public_path__ + "img/fake-qr.f0d39397.png";